
import { Box, Divider, Grid, Link } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import StyledSvgIcon from "../../components/reusable/StyledSvgIcon";
import { ReactComponent as LemonColored } from '../../SVG/lemon_2.svg';
import SlateTexture from '../../images/slate_texture.avif';

const useStyles = makeStyles()((theme) => ({
 footer: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    backgroundImage: `url(${SlateTexture})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    minHeight: '50px'
 },
}))

export default function AppFooter() {
  const { classes } = useStyles();


  return (
    <footer className={classes.footer}>
      <Grid container spacing={3} sx={{padding: {xs: 2, md: 5}, alignItems: 'center'}}>
        <Grid size={{xs: 12, md: 2}} sx={{display: 'flex', justifyContent: {xs: 'center', md: 'flex-start'}}}>
          <StyledSvgIcon component={LemonColored} viewBox="0 0 640 640" sx={{fontSize: '80px'}}/>
        </Grid>
        <Grid size={{xs: 6, md: 5}} sx={{display: 'flex', flexDirection: 'column', gap: 1, justifyContent: {xs: 'center', md: 'flex-start'}, alignItems: {xs: 'center', md: 'flex-start'}}}>
          <Link underline="hover" variant='body2' sx={{color: "common.white"}} component='a' href="/order">Order</Link>
          <Link underline="hover" variant='body2' sx={{color: "common.white"}} component='a' href="mailto:info@gyrosa.ca" target="_blank" rel="noopener noreferrer">Contact Us</Link>
        </Grid>
        <Grid size={{xs: 6, md: 5}} sx={{display: 'flex', flexDirection: 'column', gap: 1, justifyContent: {xs: 'center', md: 'flex-start'}, alignItems: {xs: 'center', md: 'flex-start'}}}>
          <Link underline="hover" variant='body2' sx={{color: "common.white"}} component='a' href="/about">About Us</Link>
          <Link underline="hover" variant='body2' sx={{color: "common.white"}} component='a' href="/careers">Careers</Link>
        </Grid>
      </Grid>
      <Box sx={{textAlign: 'center', padding: 2, color: 'common.white', fontSize: '0.875rem', borderTop: '1px solid rgba(255, 255, 255, 0.2)'}}>
        © {new Date().getFullYear()} Toasty Goats Studio.
      </Box>
    </footer>
  )
}
